function SliderReviews() {
  new Swiper(".js-slider-reviews", {
    slidesPerView: "auto",
    loop: true,
	centeredSlides: true,
    spaceBetween: 16,
    navigation: {
      nextEl: ".js-slider-reviews-button-next",
      prevEl: ".js-slider-reviews-button-prev"
    },
    pagination: {
        el: ".js-slider-reviews-pagination",
    },
    breakpoints: {
      992: {
        spaceBetween: 40,
      }
	},
	on: {
		init: function () {
			$('.js-video-frame-facybox').fancybox();
		},
	},
  });
}

export { SliderReviews };